import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { whenFree } from "@/lib/popupQueue";
import { useHalloween } from "@/lib/halloween";

const KEY = "hw_popup_seen_2026";

export function HalloweenPopup() {
  const on = useHalloween();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (on && !localStorage.getItem(KEY)) whenFree("halloween-popup", () => setOpen(true));
  }, [on]);
  if (!open || !on) return null;
  const close = () => { localStorage.setItem(KEY, "1"); setOpen(false); };
  return createPortal(
    <div className="fixed inset-0 z-[90] flex items-center justify-center p-4 bg-[#12051f]/70 backdrop-blur-sm wheel-fade" onClick={close} role="presentation" data-testid="halloween-popup">
      <div className="hw-card relative w-full max-w-sm rounded-[2rem] p-6 text-white text-center fw-rise" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="Halloween-Event">
        <button type="button" onClick={close} aria-label="Schließen" className="absolute right-3 top-3 w-9 h-9 rounded-full bg-white/15 flex items-center justify-center" data-testid="halloween-popup-close"><X className="w-4 h-4" /></button>
        <span className="text-6xl hw-float" aria-hidden>🎃</span>
        <p className="mt-2 text-[11px] font-extrabold uppercase tracking-[0.25em] text-orange-300">Nur heute Nacht · bis 6 Uhr</p>
        <h2 className="mt-1 font-display text-3xl font-black">Halloween-Event 👻</h2>
        <ul className="mt-4 space-y-2 text-left text-sm">
          <li className="rounded-2xl bg-white/10 ring-1 ring-white/15 p-3">✍️ <b>Doppelte Punkte</b> für jeden Beitrag mit dem Wort „Halloween“</li>
          <li className="rounded-2xl bg-white/10 ring-1 ring-white/15 p-3">🧛 <b>Kostüm-Wettbewerb:</b> Foto posten, Herzen sammeln – Top 3 gewinnen 500 / 300 / 150 Punkte</li>
        </ul>
        <Link to="/halloween" onClick={close} className="mt-5 inline-flex items-center justify-center w-full h-12 rounded-full bg-gradient-to-r from-orange-400 to-orange-600 font-black shadow-lg" data-testid="halloween-popup-cta">Jetzt mitmachen</Link>
        <button type="button" onClick={close} className="mt-2 h-10 text-sm font-bold text-white/70" data-testid="halloween-popup-later">Später</button>
      </div>
    </div>,
    document.body,
  );
}
